import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import { SceneEmail } from '../SceneEmail';

export default function Banner() {
    const { t } = useLang('powerbackup');
    const { locale } = getLocal();

    return (
        <div className={`${styles.Banner} GtmModuleData-section`}>
            <EcoImg
                pc="https://websiteoss.ecoflow.com/figma-uploads/1767666828052-7i1iwm-compressed-home-carousel-banner.jpg"
                pad="https://websiteoss.ecoflow.com/figma-uploads/1769395235390-aioc93-compressed-home-carousel-banner.jpg"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1769395235390-aioc93-compressed-home-carousel-banner.jpg"
            />

            <div className="wrapper">
                <div className="title">{t('secA_title')}</div>
                <div className="desc-box">
                    <SceneEmail theme="white" type="BATTERY_BACKUP" title={t('secA_title')} />
                </div>
            </div>
        </div>
    );
}
